var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophies1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 12H6.00033C5.11627 12 4.26842 11.6488 3.6433 11.0237C3.01818 10.3985 2.66699 9.5507 2.66699 8.66665C2.66699 7.78259 3.01818 6.93475 3.6433 6.30962C4.26842 5.6845 5.11627 5.33331 6.00033 5.33331H8.00033",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12H26C26.8841 12 27.7319 11.6488 28.357 11.0237C28.9821 10.3985 29.3333 9.5507 29.3333 8.66665C29.3333 7.78259 28.9821 6.93475 28.357 6.30962C27.7319 5.6845 26.8841 5.33331 26 5.33331H24",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 29.3333H26.6663",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 19.5467V22.6667C13.333 23.4 12.7063 23.9734 12.0397 24.28C10.4663 25 9.33301 26.9867 9.33301 29.3334",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 19.5467V22.6667C18.667 23.4 19.2937 23.9734 19.9603 24.28C21.5337 25 22.667 26.9867 22.667 29.3334",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.66669H8V12C8 14.1218 8.84286 16.1566 10.3431 17.6569C11.8434 19.1572 13.8783 20 16 20C18.1217 20 20.1566 19.1572 21.6569 17.6569C23.1571 16.1566 24 14.1218 24 12V2.66669Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophies1);
export default __webpack_public_path__ + "static/media/trophies-1.1cec01a7597a0ac31a1641cfb0121833.svg";
export { ForwardRef as ReactComponent };